import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'lostTripList',
    initialState: {
        isRequesting: false,
        error: null,
        data: [],
        total: 0,
        searchLostTrip: {},
    },
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchLostTrip: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload.data.items,
                total: action.payload.data.total,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
            };
        },
        update_lost_trip: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        update_lost_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        export_lost_trip: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
